module.exports = __webpack_public_path__ + "static/media/area.61c90319.svg";